import { useState, useEffect, KeyboardEvent, ChangeEvent } from 'react';
import useStyles from './styles';
import { CSSProperties } from '@mui/styles';
import { Input, ClassNameMap } from '@mui/material';
import { Clear } from '@mui/icons-material';

interface SearchBarProps {
  id: string;
  placeHolder?: string;
  defaultValue?: string;
  onChange?: (text: string) => void;
  onSearch: (text: string) => void;
  onClear?: () => void;
  wrapperStyle?: CSSProperties;
}

const SearchBar = ({
  id,
  placeHolder,
  defaultValue,
  onChange,
  onSearch,
  onClear,
  wrapperStyle = {},
}: SearchBarProps) => {
  const classes: ClassNameMap = useStyles();
  const [value, setValue] = useState<string>('');

  const onTypeSearch = (e: KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSearch(value);
    }
  };

  useEffect(() => {
    setValue(defaultValue ?? '');
  }, [defaultValue]);

  return (
    <div className={classes.advancedSearchWrapper} style={wrapperStyle}>
      <Input
        className={classes.searchInput}
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setValue(e.target.value);
          if (onChange) onChange(e.target.value);
        }}
        id={id}
        onKeyDown={onTypeSearch}
        placeholder={placeHolder}
        inputProps={{ maxLength: 255 }}
        style={{ minHeight: '40px', marginRight: '10px' }}
      />
      {value && onClear ? (
        <Clear
          className={classes.clearTextButton}
          onClick={() => {
            if (!value) return;
            onClear();
            setValue('');
          }}
        />
      ) : null}
    </div>
  );
};

export default SearchBar;
